// import { useState } from "react";
// import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
// import { Box, IconButton,  Typography, useTheme } from "@mui/material";
// import { Link } from "react-router-dom";
// import "react-pro-sidebar/dist/css/styles.css";
// import { tokens } from "../../theme";

// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

// import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
// import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
// import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";

// import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

// import {  AddCircleOutline,  Description, InsertCommentOutlined, InsertCommentSharp, Logout, ManageAccounts, MapsHomeWork,  People, WaterSharp, } from "@mui/icons-material";

// import { AuthProvider, useAuth } from "../../AuthContext";
// const Item = ({ title, to, icon, selected, setSelected,onClick }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   return (
//     <MenuItem
//       active={selected === title}
//       style={{
//         color: colors.grey[100],
//       }}
//        onClick={() => setSelected(title)}
     
//       icon={icon}
//     >
//       <Typography>{title}</Typography>
//       <Link to={to} />
//     </MenuItem>
//   );
// };

// const Sidebar = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [selected, setSelected] = useState("Dashboard");
//   //const navigate = useNavigate(); 

// // Child component to handle routing and auth logic

//   const { isAuthenticated, clearTokens } = useAuth(); // Now safe to use useAuth

//   // Handle logout
//   const handleLogout = () => {
//     clearTokens(); // Clear tokens and set isAuthenticated to false
//   };
//   // const handleLogout = () => {
//   //   console.log("Logout clicked"); // ✅ Debugging step
//   //   localStorage.removeItem("token"); // ✅ Clear authentication tokens
//   //   sessionStorage.removeItem("user"); // ✅ Clear session storage
//   //   window.location.replace("/login"); 
//   //   //navigate("/login"); // ✅ Navigate to login
//   // };
//   const handleDownloadReports = async () => {
//     const response = await fetch(`http://52.66.242.0/daily_csv_report`);
//     const blob = await response.blob();
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = 'daily_report.csv';
//     a.click();
//     URL.revokeObjectURL(url);
//   };
//   return (
//     <Box
//       sx={{
//        // display: "flex",
//         height: "120vh", // Full viewport height
//         "& .pro-sidebar": {
//           height: "120vh", // Full viewport height
//         },
//         "& .pro-sidebar-inner": {
//            height: "120vh",
//           background: `${colors.primary[400]} !important`,
//         },
//         "& .pro-icon-wrapper": {
//           backgroundColor: "transparent !important",
//         },
//         "& .pro-inner-item": {
//           padding: "5px 35px 5px 10px !important",
//         },
//         "& .pro-inner-item:hover": {
//           color: "#868dfb !important",
//         },
//         "& .pro-menu-item.active": {
//           color: "#6870fa !important",
//         },
//       }}
//     >
//       <ProSidebar collapsed={isCollapsed} style={{height:'100vh'}} >
//         <Menu iconShape="square" >
//           {/* LOGO AND MENU ICON */}
//           <MenuItem
//             onClick={() => setIsCollapsed(!isCollapsed)}
//             icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
//             style={{
//               margin: "2px 0 0px 0",
//               color: colors.grey[100],
//             }}
//           >
//             {!isCollapsed && (
//               <Box
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 ml="15px"
//               >
//                 {/* <Typography variant="h3" color={colors.grey[100]}>
//                   ADMIN
//                 </Typography> */}
//                 {/* <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
//                   <MenuOutlinedIcon />
//                 </IconButton> */}
//               </Box>
//             )}
//           </MenuItem>

//           {!isCollapsed && (
//             <Box mb="20px">
               
//               <Box display="flex" justifyContent="center" alignItems="center">
//                 <img
//                   alt="profile-user"
//                   width="200px"
//                   height="50px"
//                   src={`../../assets/user.png`}
//                   style={{ cursor: "pointer", borderRadius: "50%" }}
//                 />
              
//               <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
//                   <MenuOutlinedIcon />
//                 </IconButton>
//                 </Box>
//               <Box textAlign="center">
//                 <Typography
//                   variant="h4"
//                   color={colors.grey[100]}
//                   fontWeight="bold"
//                   sx={{ m: "10px 0 0 0" }}
//                 >
//                  Servotech Renewable Power System
//                 </Typography>
//               </Box>
//             </Box>
//           )}

//           <Box paddingLeft={isCollapsed ? undefined : "5%"}>
//             <Item
//               title="Dashboard"
//               to="/"
//               icon={<HomeOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />

//             <Typography
//               variant="h6"
//               color={colors.grey[300]}
//               sx={{ m: "15px 0 5px 20px" }}
//             >
//               Pages
//             </Typography>
//             <SubMenu
//              title="Pumps"
//              icon={<WaterSharp />}
//              //defaultOpen
//              style={{ color: colors.grey[100] }}
//              sx={{ "& .pro-menu-title": { display: "block !important" } }} // Fix for hidden labels
//             >
//                   <Item
//                     title="Pumps"
//                     to="/pumps"
//                     icon={<WaterSharp/>}
//                     selected={selected}
//                     setSelected={setSelected}
//                   />
//                   <Item
//                     title="Manage Pumps"
//                     to="/managePumps"
//                     icon={<WaterSharp/>}
//                     selected={selected}
//                     setSelected={setSelected}
//                   />
//           </SubMenu>
//           <SubMenu
//              title="Consumers"
//              icon={<People />}
             
//              style={{ color: colors.grey[100] }}
//              sx={{ "& .pro-menu-title": { display: "block !important" } }} // Fix for hidden labels
//             >
//               <Item
//                 title="Consumers"
//                 to="/consumers"
//                 icon={<PersonOutlinedIcon />}
//                 selected={selected}
//                 setSelected={setSelected}
//               />
//               <Item
//                 title="Manage Consumers"
//                 to="/manageConsumers"
//                 icon={<AddCircleOutline />}
//                 selected={selected}
//                 setSelected={setSelected}
//               />
            
//             </SubMenu>
//             <SubMenu
//              title="Complaints"
//              icon={<InsertCommentSharp />}
//              style={{ color: colors.grey[100] }}
//              sx={{ "& .pro-menu-title": { display: "block !important" } }} // Fix for hidden labels
//             >
//               <Item
//                 title="Complaints"
//                 to="/complaints"
//                 icon={<InsertCommentOutlined />}
//                 selected={selected}
//                 setSelected={setSelected}
//               />
//               <Item
//                 title="Manage Complaints"
//                 to="/manageComplaints"
//                 icon={<AddCircleOutline />}
//                 selected={selected}
//                 setSelected={setSelected}
//               />
            
//             </SubMenu>
//             <Item
//               title="Geolocation"
//               to="/geography"
//               icon={<MapsHomeWork />}
//               selected={selected}
//               setSelected={setSelected}
//             />
//              <MenuItem
            
//             title="Reports"
//             icon={<Description />}
//             onClick={handleDownloadReports} // ✅ Ensure function is properly attached
//             style={{ color: colors.grey[100] }}
//           >
//             <Typography variant="h6">Reports</Typography>
//           </MenuItem>
           
//             <MenuItem
            
//             title="Logout"
//             icon={<Logout />}
//             onClick={handleLogout} // ✅ Ensure function is properly attached
//             style={{ color: colors.grey[100], }}
//           >
//             <Typography variant="h6">Logout</Typography>
//           </MenuItem>
//             <Item
//               title="FAQ Page"
//               to="/faq"
//               icon={<HelpOutlineOutlinedIcon />}
//               selected={selected}
//               setSelected={setSelected}
//             />
            
//           </Box>
//         </Menu>
//       </ProSidebar>
//     </Box>
//   );
// };

// export default Sidebar;




import { useState } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { AddCircleOutline, Description, InsertCommentOutlined, InsertCommentSharp, Logout, ManageAccounts, MapsHomeWork, People, Settings, WaterSharp } from "@mui/icons-material";
import { useAuth } from "../../AuthContext";

const Item = ({ title, to, icon, selected, setSelected, isCollapsed }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const menuItem = (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
      aria-label={title}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );

  return isCollapsed ? (
    <Tooltip
      title={title} // Added title prop to Tooltip
      placement="right"
      arrow
      sx={{
        "& .MuiTooltip-tooltip": {
          backgroundColor: colors.primary[400],
          color: colors.grey[100],
          fontSize: "0.875rem",
          padding: "8px 12px",
          borderRadius: "4px",
        },
        "& .MuiTooltip-arrow": {
          color: colors.primary[400],
        },
      }}
    >
      <span>{menuItem}</span>
    </Tooltip>
  ) : (
    menuItem
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");
  const { isAuthenticated, clearTokens, userRole } = useAuth();

  const handleLogout = () => {
    clearTokens();
  };

  const handleDownloadReports = async () => {
    try {
      const response = await fetch(`http://52.66.242.0/daily_csv_report`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'daily_report.csv';
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download report:", error);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100%",
        "& .pro-sidebar": {
          minHeight: "100%",
        },
        "& .pro-sidebar-inner": {
          minHeight: "90vh",
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 10px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed} style={{ height: '100vh' }}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "2px 0 0px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="20px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="200px"
                  height="50px"
                  src={`../../assets/user.png`}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h4"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  Servotech Renewable Power System
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "5%"}>
            <Item
              title="Dashboard"
              to="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={isCollapsed}
            />
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Pages
            </Typography>
            <Tooltip
              title="Pumps"
              placement="right"
              disableHoverListener={!isCollapsed}
              sx={{
                "& .MuiTooltip-tooltip": {
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100],
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "4px",
                },
                "& .MuiTooltip-arrow": {
                  color: colors.primary[400],
                },
              }}
            >
              <span>
                <SubMenu
                  title="Pumps"
                  icon={<WaterSharp />}
                  style={{ color: colors.grey[100] }}
                  sx={{ "& .pro-menu-title": { display: "block !important" } }}
                >
                  <Item
                    title="Pumps"
                    to="/pumps"
                    icon={<WaterSharp />}
                    selected={selected}
                    setSelected={setSelected}
                    isCollapsed={isCollapsed}
                  />
                  <Item
                    title="Manage Pumps"
                    to="/managePumps"
                    icon={<WaterSharp />}
                    selected={selected}
                    setSelected={setSelected}
                    isCollapsed={isCollapsed}
                  />
                </SubMenu>
              </span>
            </Tooltip>
            <Tooltip
              title="Consumers"
              placement="right"
              disableHoverListener={!isCollapsed}
              sx={{
                "& .MuiTooltip-tooltip": {
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100],
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "4px",
                },
                "& .MuiTooltip-arrow": {
                  color: colors.primary[400],
                },
              }}
            >
              <span>
                <SubMenu
                  title="Consumers"
                  icon={<People />}
                  style={{ color: colors.grey[100] }}
                  sx={{ "& .pro-menu-title": { display: "block !important" } }}
                >
                  <Item
                    title="Consumers"
                    to="/consumers"
                    icon={<PersonOutlinedIcon />}
                    selected={selected}
                    setSelected={setSelected}
                    isCollapsed={isCollapsed}
                  />
                  <Item
                    title="Manage Consumers"
                    to="/manageConsumers"
                    icon={<AddCircleOutline />}
                    selected={selected}
                    setSelected={setSelected}
                    isCollapsed={isCollapsed}
                  />
                </SubMenu>
              </span>
            </Tooltip>
            <Tooltip
              title="Complaints"
              placement="right"
              disableHoverListener={!isCollapsed}
              sx={{
                "& .MuiTooltip-tooltip": {
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100],
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "4px",
                },
                "& .MuiTooltip-arrow": {
                  color: colors.primary[400],
                },
              }}
            >
              <span>
                
                  <Item
                    title="Complaints"
                    to="/complaints"
                    icon={<InsertCommentSharp />}
                    selected={selected}
                    setSelected={setSelected}
                    isCollapsed={isCollapsed}
                  />
                
                
              </span>
            </Tooltip>
  <Item
              title="Pump Configuration"
              to="/pumpConfigUpdate"
              icon={<Settings />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={isCollapsed}
            />

            <Item
              title="Geolocation"
              to="/geography"
              icon={<MapsHomeWork />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={isCollapsed}
            />
            <Tooltip
              title="Reports"
              placement="right"
              disableHoverListener={!isCollapsed}
              sx={{
                "& .MuiTooltip-tooltip": {
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100],
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "4px",
                },
                "& .MuiTooltip-arrow": {
                  color: colors.primary[400],
                },
              }}
            >
              <span>
                 
                
                  <Item
                    title="Reports"
                    to="/reports"
                    icon={<Description />}
                    selected={selected}
                    setSelected={setSelected}
                    isCollapsed={isCollapsed}
                  />
                
                
              </span>
                
            </Tooltip>

            {userRole === "admin" && (
              <Item
                title="Manage Users"
                to="/dashboardUsers"
                icon={<ManageAccounts />}
                selected={selected}
                setSelected={setSelected}
                isCollapsed={isCollapsed}
              />
            )}

            <Tooltip
              title="Logout"
              placement="right"
              disableHoverListener={!isCollapsed}
              sx={{
                "& .MuiTooltip-tooltip": {
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100],
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "4px",
                },
                "& .MuiTooltip-arrow": {
                  color: colors.primary[400],
                },
              }}
            >
              <span>
                <MenuItem
                  title="Logout"
                  icon={<Logout />}
                  onClick={handleLogout}
                  style={{ color: colors.grey[100] }}
                >
                  <Typography variant="h6">Logout</Typography>
                </MenuItem>
              </span>
            </Tooltip>
            <Item
              title="FAQ Page"
              to="/faq"
              icon={<HelpOutlineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              isCollapsed={isCollapsed}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;